import Config from '../../../../FocusManager/Config';
import FocusManagerFacade from '../../../../FocusManager/FocusManagerFacade';
import noop from '../../../../Shared/Util/noop';

const fallbackFocusManagerFacade: FocusManagerFacade = {
    config: new Config(),
    root: null,
    focusedNode: null,
    registeredNodes: {},
    addEventListener: noop,
    removeEventListener: noop,
    blur: noop,
    configure: noop,
    down: noop,
    focus: noop,
    left: noop,
    right: noop,
    select: noop,
    up: noop,
};

export default fallbackFocusManagerFacade;
